import React, { useState, useEffect } from "react";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import AdminOrderCard from "../../shares/AdminOrderCard";
import MuiSelect from "../../../shares/MuiSelect";
import {
  translateGender,
  translateColor,
  EmptyData,
  fixNumbers,
} from "../../../../utils";
// import { defaultRingSize, showNumSix } from "../../../../constants/constants";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { useSetting } from "../../../../context/SettingContext";

const statusList = [
  {
    name: "تغییر داده شده",
    value: true,
  },
  {
    name: "تغییر داده نشده",
    value: false,
  },
];

const DeliverOrderRing = (props) => {
  let windowWidth = window.screen.width;
  const { defaultRingSize, showNumSix } = useSetting();
  const [openModal, setOpenModal] = useState(false);

  const [statusFilter, setStatusFilter] = useState("all");

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getOrderDetailsApi = useFetch({
    method: "get",
    url: `Bangle_Service/${props.selectedRow?.id}/admin_get_provider_order_item_detail_from_order_using_bangle`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.admin_size_one_num);
        tmp[item.id].push(item.admin_size_two_num);
        tmp[item.id].push(item.admin_size_three_num);
        tmp[item.id].push(item.admin_size_four_num);
        tmp[item.id].push(item.admin_size_five_num);
        tmp[item.id].push(item.admin_size_six_num);
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `ProviderOrderItem_Service/${selectedItem}/provider_update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderDetailsApi.reFetch();
      // props.getRingsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      admin_change_item: true,
    });
    updateDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };
  const resetUpdateDetailsApi = useFetch({
    method: "get",
    url: `ProviderOrderItem_Service/${selectedItem}/reset_provider_update_order_item`,
    trigger: false,
    // data: patchData,

    argFunc: (res) => {
      setCurrentOerdersDetail({
        results: [],
        detail: {},
      });
      // props.adminGetCustomerCurrentOrderApi.reFetch();
      getOrderDetailsApi.reFetch();
      props.getRingsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const reset_update_ring_item = () => {
    resetUpdateDetailsApi.reFetch();
  };
  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<SyncAltIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
        RefetchNeed
        apiCall={props.getRingsApi}
      >
        <div>
          <div className="flex justify-center">
            <div className="add-item-container">
              <span className="show-label">
                کد:{" "}
                <span className="show-value"> {props.selectedRow?.code}</span>
              </span>
            </div>
            <div className="add-item-container">
              <span className="show-label mx-2 shrink-0">
                النگو:{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.show_name}
                </span>
              </span>
            </div>
            <div className="add-item-container">
              <span className="show-label mx-2 shrink-0">
                سن:{" "}
                <span className="show-value">
                  {" "}
                  {translateGender(props.selectedRow?.gender)}
                </span>
              </span>
            </div>
            <div className="add-item-container">
              <span className="show-label mx-2 shrink-0">
                رنگ:{" "}
                <span className="show-value">
                  {" "}
                  {translateColor(props.selectedRow?.color)}
                </span>
              </span>
            </div>
            <div className="add-item-container">
              <span className="show-label">
                برند:{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.brand_name}
                </span>
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span className="basis-1/2 md:basis-4/5 text-xs md:text-sm">
              برای مشاهده وضعیت سفارش ها فیلتر لازم را اعمال نمایید.
            </span>
            <div className="basis-1/2 md:basis-1/5">
              <MuiSelect
                size="small"
                inputLabel="وضعیت"
                labelId="status-label"
                id="status-select"
                label="status"
                menuItems={statusList}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  getOrderDetailsApi.reFetch();
                }}
                value={statusFilter !== null ? statusFilter : "all"}
                defaultValue="all"
                haveAllOption={true}
              />
            </div>
          </div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="md:max-h-96 md:overflow-scroll">
            {currentOerdersDetail.results.length > 0 ? (
              <>
                {currentOerdersDetail.results.map((item, index) => {
                  return [
                    <AdminOrderCard
                      update_ring_item={update_ring_item}
                      reset_update_ring_item={reset_update_ring_item}
                      showResetAcceptBtn
                      showAcceptBtn
                      DontshowEditIconForAdmin
                      item={item}
                      move_date_to_parent={move_date_to_parent}
                      baseFromRing
                      adminNeedDifference
                    >
                      <OrderCardLeftPartTemplate
                        nums={nums}
                        update_nums={update_nums}
                        dynamicMap={true}
                        data_item={item}
                        ringId={item.id}
                        cantEdit
                        adminDidntNeedCustomerRequestNum
                        adminNeedColor
                      />
                    </AdminOrderCard>,
                  ];
                })}
              </>
            ) : (
              <EmptyData text="نتیجه ای یافت نشد!" />
            )}
          </div>
          <div className="border rounded-lg py-2 px-6  mt-2 flex items-center">
            <div className="">
              <span className="font-bold text-myblue-100">
                مجموع اختلاف‌ها:
              </span>
              <>
                {showNumSix ? (
                  <>
                    <span
                      className={
                        props.selectedRow?.count_sizes.diff_size_six_num <= 0
                          ? "text-green-700 mr-2"
                          : "text-red-700 mr-2"
                      }
                    >
                      {Math.abs(
                        props.selectedRow?.count_sizes.diff_size_six_num
                      )}
                    </span>
                    {" / "}
                  </>
                ) : (
                  ""
                )}
                <span
                  className={
                    props.selectedRow?.count_sizes.diff_size_five_num <= 0
                      ? "text-green-700 mr-2"
                      : "text-red-700 mr-2"
                  }
                >
                  {Math.abs(props.selectedRow?.count_sizes.diff_size_five_num)}
                </span>
                {" / "}
                <span
                  className={
                    props.selectedRow?.count_sizes.diff_size_four_num <= 0
                      ? "text-green-700 mr-2"
                      : "text-red-700 mr-2"
                  }
                >
                  {Math.abs(props.selectedRow?.count_sizes.diff_size_four_num)}
                </span>
                {" / "}
                <span
                  className={
                    props.selectedRow?.count_sizes.diff_size_three_num <= 0
                      ? "text-green-700 mr-2"
                      : "text-red-700 mr-2"
                  }
                >
                  {Math.abs(props.selectedRow?.count_sizes.diff_size_three_num)}
                </span>
                {" / "}
                <span
                  className={
                    props.selectedRow?.count_sizes.diff_size_two_num <= 0
                      ? "text-green-700 mr-2"
                      : "text-red-700 mr-2"
                  }
                >
                  {Math.abs(props.selectedRow?.count_sizes.diff_size_two_num)}
                </span>
                {" / "}
                <span
                  className={
                    props.selectedRow?.count_sizes.diff_size_one_num <= 0
                      ? "text-green-700 mr-2"
                      : "text-red-700 mr-2"
                  }
                >
                  {Math.abs(props.selectedRow?.count_sizes.diff_size_one_num)}
                </span>
              </>
            </div>
            <div className="mr-16">
              <span className="font-bold text-myblue-100">مجموع پذیرش‌ها:</span>
              <span className="mr-4">
                {showNumSix ? (
                  <>
                    {props.selectedRow?.count_sizes.admin_size_six_num}
                    {" / "}
                  </>
                ) : (
                  ""
                )}
                {props.selectedRow?.count_sizes.admin_size_five_num}
                {" / "}
                {props.selectedRow?.count_sizes.admin_size_four_num}
                {" / "}
                {props.selectedRow?.count_sizes.admin_size_three_num}
                {" / "}
                {props.selectedRow?.count_sizes.admin_size_two_num}
                {" / "}
                {props.selectedRow?.count_sizes.admin_size_one_num}
              </span>
            </div>
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default DeliverOrderRing;
